<template>
    <div>
        <headNav />
        <router-view style="min-height: 100vh;padding-top:66px;"></router-view>
        <!-- <bottom /> -->
    </div>
</template>

<script>
    import headNav from "@/components/headNav";
    import bottom from "@/components/bottomNav";
    export default {
        name: 'Home',
        components: {
            headNav,
            bottom,
        },
        data() {
            return {

            };
        },
        created() {

        },
    };
</script>